// Per-user MCP "connected" attribution.
//
// The OAuth connector binds each issued token to the consenting user, so it
// records BOTH a company-level signal (mcpLastRequestAt) and a per-user one
// (mcpUsersSeen.{uid}, keyed by Firebase uid === user.userId). We only want to
// show MCP as "set up" for the user who actually connected it, not their whole
// team — so OAuth usage is gated on the current user appearing in mcpUsersSeen.
//
// The API-key path (functions/mcpAPI.js) is company-scoped — one shared key, no
// way to attribute a request to an individual — so it stays company-wide. It
// writes ONLY mcpLastRequestAt; the OAuth path additionally writes
// mcpClientsSeen / mcpUsersSeen. So a stamped mcpLastRequestAt with NEITHER of
// those present is API-key usage, which we keep showing to everyone.
//
// Edge cases (both self-heal / are the intended bias, no special handling):
//   - A user who OAuth-connected before per-user attribution shipped isn't in
//     mcpUsersSeen yet, so they read "not set up" until their token next
//     refreshes (which repopulates it).
//   - A company using BOTH API-key and OAuth: an API-key-only user who never
//     logged in via OAuth reads "not set up" — they personally never connected.
//
// `companyData` here is the unwrapped company doc (no `.data` envelope), matching
// what CompanyContext exposes.
export function isMcpConnectedForUser(companyData, userId) {
    const usersSeen = companyData?.mcpUsersSeen || {};
    const clientsSeen = companyData?.mcpClientsSeen || {};
    const currentUserUsedMcp = !!(userId && usersSeen[userId]);
    const companyLevelMcpUsage = !!companyData?.mcpLastRequestAt
        && Object.keys(clientsSeen).length === 0
        && Object.keys(usersSeen).length === 0;
    return currentUserUsedMcp || companyLevelMcpUsage;
}
